import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import { buildValidationRules } from '../utils/fieldUtils'

function NumberFieldEditor ({ field, control, form }) {
  const rules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydInput
            {...hookField}
            minWidth='0'
            type='number'
            placeholder={field.label}
          />
        </SydLabel>
      )}
    />
  )
}

NumberFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default NumberFieldEditor
